import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { BaseDataService } from './base-data-service';
import {
  StepResponse,
  StepRequest,
  CheckAutoDeclineResponse,
  AutoDeclineRequest,
  ReferralCheckRequest,
  ReferralCheckResponse,
  ActivityLogRequest,
  ActivityLogResponse,
  DocumentsResponse
} from './def/steps';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IsTrue } from 'libs/util/binary-util';
import { GlobalVariablesService } from './global-variables.service';

@Injectable({
  providedIn: 'root'
})
export class StepsService extends BaseDataService {
  loaded: boolean;
  data;
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);
  }

  getPolicyDetails(payload: StepRequest): Observable<StepResponse> {
    const url = `${this.serviceBaseUrl}/policy/${payload.policyId}/${payload.versionNum}`;
    return this.get<StepResponse>(url);
  }

  getDocumentsDetail(payload: StepRequest): Observable<DocumentsResponse> {
    const url = `${this.serviceBaseUrl}/policy/${payload.policyId}/${payload.versionNum}/documents`;
    return this.get<DocumentsResponse>(url);
  }

  changePolicyTerm(params: StepRequest): Observable<StepResponse> {
    const url = `${this.serviceBaseUrl}/policy/change-policy-term`;
    return this.post<StepResponse>(url, { body: params });
  }

  checkAutoDecline(payload: StepRequest): Observable<CheckAutoDeclineResponse> {
    const url = `${this.serviceBaseUrl}/policy/check-auto-decline/${payload.policyId}/${payload.versionNum}`;
    return this.get<CheckAutoDeclineResponse>(url);
  }
  activityLogItem(
    payload: ActivityLogRequest
  ): Observable<ActivityLogResponse> {
    const url = `${this.serviceBaseUrl}/infinity/create-activity-log-item`;
    return this.post<ActivityLogResponse>(url, { body: payload });
  }
  autoDecline(
    payload: AutoDeclineRequest
  ): Observable<CheckAutoDeclineResponse> {
    const url = `${this.serviceBaseUrl}/policy/decline-policy`;
    return this.put<CheckAutoDeclineResponse>(url, { body: payload });
  }

  referralCheck(
    payload: ReferralCheckRequest
  ): Observable<ReferralCheckResponse> {
    const url = `${this.serviceBaseUrl}/policy/underwriter-policy-referralcheck`;
    return this.put<ReferralCheckResponse>(url, { body: payload });
  }
}
